import { FC } from "react";

import { useTranslate } from "@/common/hooks/useTranslate";
import { FormButton } from "@/forms-design-system/FormButton";
import { FormInfobox, FormInfoboxProps } from "@/forms-design-system/FormInfobox";
import { Info } from "@/icons/outlined";

type ZeffySplitOrCoverFeesInfoboxProps = Omit<
  FormInfoboxProps,
  "icon" | "title" | "description" | "components" | "variant" | "callToActions" | "onDismiss"
> & {
  formattedFees: string;
  organizationName: string;
  bankPaymentMethodLabel: string;
  onSplitFeesClick: () => void;
  onCoverFeesClick: () => void;
  onDismiss: () => void;
};

export const ZeffySplitOrCoverFeesInfobox: FC<ZeffySplitOrCoverFeesInfoboxProps> = ({
  organizationName,
  bankPaymentMethodLabel,
  formattedFees,
  onSplitFeesClick,
  onCoverFeesClick,
  onDismiss,
  ...rest
}) => {
  const { t } = useTranslate();
  return (
    <FormInfobox
      {...rest}
      variant="emphasis"
      icon={<Info />}
      title={t("common", "payment.coverFees.title")}
      description={t("common", "payment.coverFees.messageA", {
        orgName: organizationName,
        bankPaymentMethod: bankPaymentMethodLabel,
      })}
      callToActions={[
        <FormButton key="coverFees" onClick={onCoverFeesClick}>
          {t("common", "payment.coverFees.coverFees", { formattedFees })}
        </FormButton>,
        <FormButton key="splitFees" variant="tonal" onClick={onSplitFeesClick}>
          {t("common", "payment.coverFees.splitFees")}
        </FormButton>,
      ]}
      onDismiss={onDismiss}
    />
  );
};
